import { createContext, useContext } from "react";

export type Options = {
  id: string;
  isopen: boolean;
  numberOfWeek:number;
  day:number,
  month:number,
  year:number,
  isEditing: boolean; 
  isViewing: boolean;
  isCreating: boolean;
}

export const ModalEventContext = createContext<{ options: Options; setOptions: React.Dispatch<React.SetStateAction<Options>> } | undefined>(undefined);

export const useModalEvent = () => {
  const context = useContext(ModalEventContext);
  if (!context) {
    throw new Error('useOpenModalEvent must be used within a ModalEventContext.provider');
  }
  return context;
};